var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:lock-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 44C10.9 44 9.958 43.608 9.174 42.824C8.39 42.04 7.99867 41.0987 8 40V20C8 18.9 8.392 17.958 9.176 17.174C9.96 16.39 10.9013 15.9987 12 16H14V12C14 9.23333 14.9753 6.87467 16.926 4.924C18.8767 2.97333 21.2347 1.99867 24 2C26.7667 2 29.1253 2.97533 31.076 4.926C33.0267 6.87667 34.0013 9.23467 34 12V16H36C37.1 16 38.042 16.392 38.826 17.176C39.61 17.96 40.0013 18.9013 40 20V40C40 41.1 39.608 42.042 38.824 42.826C38.04 43.61 37.0987 44.0013 36 44H12ZM12 40H36V20H12V40ZM24 34C25.1 34 26.042 33.608 26.826 32.824C27.61 32.04 28.0013 31.0987 28 30C28 28.9 27.608 27.958 26.824 27.174C26.04 26.39 25.0987 25.9987 24 26C22.9 26 21.958 26.392 21.174 27.176C20.39 27.96 19.9987 28.9013 20 30C20 31.1 20.392 32.042 21.176 32.826C21.96 33.61 22.9013 34.0013 24 34ZM18 16H30V12C30 10.3333 29.4167 8.91667 28.25 7.75C27.0833 6.58333 25.6667 6 24 6C22.3333 6 20.9167 6.58333 19.75 7.75C18.5833 8.91667 18 10.3333 18 12V16Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.1d4cab32d9612fafa21499cc26609f82.svg";
export { ForwardRef as ReactComponent };